import { useModal } from "../contexts";
import Modal from './Modal';
import useUser from '../hooks/useUser';

interface Props {
  oauthUrl: string;
  onClose?: () => void;
}

function OAuthModalXero(props: Props) {
  const { closeModal } = useModal();
  const { refreshUser } = useUser();

  function handleInstallIntegration() {
    window.open(props.oauthUrl, "_blank");
    window.addEventListener("focus", getCurrentUserOnFocus);
  }

  async function getCurrentUserOnFocus() {
    window.removeEventListener("focus", getCurrentUserOnFocus);

    refreshUser();
    closeModal(props.onClose);
  }

  return (
    <Modal>
      <div className="flex flex-col items-center justify-center gap-8 bg-white" style={{ width: "600px", height: "400px" }}>
        <div className="text-2xl text-center font-gilroy font-bold">Authorise Xero with Portant</div>
        <div className="flex flex-col gap-4 text-gray-400 w-4/5">
          Portant requires access to invoice data within your Xero account.
        </div>
        <div className="bg-blue text-white font-semibold py-2 px-4 rounded cursor-pointer" onClick={handleInstallIntegration}>
          Authorise Xero with Portant
        </div>
      </div>
    </Modal>
  );
}

export default OAuthModalXero;
